import React, { useContext } from "react";
import { generateClassString as gcs } from "../../../../lib/helper/generateClassString";
import t from "../../../../lib/translate";

import { Headline } from "../../../../components/Headline";
import { ImageWithGrid } from "../../../../components/Image";
import { StructuredTextRenderer } from "../../../../components/StructuredTextRenderer";
import { Tagline } from "../../../../components/Tagline/Tagline";
import { TeaserButton } from "../../../../components/teaser-components/TeaserButton/TeaserButton";

import * as styles from "./MediaTextTeaserElement.module.less";
import {
    useIsDesktop,
    useIsSmaller1400
} from "../../../../lib/hooks/mediaQueries";
import GeneralPageContext from "../../../../templates/GeneralPageContext";

export function MediaTextTeaserElement({
    children,
    teaserData: {
        tagline,
        headline,
        semanticOfHeadline,
        image,
        division,
        text,
        document,
        url,
        link
    },
    horizontalLayout,
    mediaAlignLeft,
    hasLightBackground = true
}) {
    const {
        layout: { showAnchorNavigation }
    } = useContext(GeneralPageContext);
    const isDesktop = useIsDesktop();
    const isSmaller1400 = useIsSmaller1400();
    return (
        <div
            className={gcs(
                styles.mediaTextTeaserElement,
                [horizontalLayout, styles.horizontal, styles.vertical],
                [!mediaAlignLeft && horizontalLayout, styles.alignMediaRight],
                [showAnchorNavigation, styles.anchored]
            )}
        >
            {/* Teaser Image */}
            {image && (
                <div className={styles.imageWrapper}>
                    <ImageWithGrid
                        className={gcs(
                            styles.teaserImage,
                            [horizontalLayout, styles.horizontalImage],
                            [showAnchorNavigation, styles.anchored]
                        )}
                        // prettier-ignore
                        gridSize={showAnchorNavigation ? (isSmaller1400 ? "s" : "m") : (isDesktop ? "s": "m")}
                        image={image}
                    />
                </div>
            )}

            <div
                className={gcs(styles.teaserContent, [
                    horizontalLayout,
                    styles.horizontalContent
                ])}
            >
                {/* Teaser Heading */}
                <div className={styles.heading}>
                    {tagline && (
                        <Tagline hasLightBackground={hasLightBackground}>
                            {tagline}
                        </Tagline>
                    )}

                    {division &&
                        (Array.isArray(division) ? (
                            division.map((div) => (
                                <span key={div.id}>{div.name}</span>
                            ))
                        ) : (
                            <span>{division.name}</span>
                        ))}

                    <Headline
                        semanticOfHeadline={semanticOfHeadline}
                        hasLightBackground={hasLightBackground}
                    >
                        {headline}
                    </Headline>
                </div>

                {/* Teaser Content */}
                <div className={styles.additionalContent}>
                    {text?.value && (
                        <StructuredTextRenderer
                            data={text}
                            contentElementType={"MediaTextTeaserElement"}
                        />
                    )}

                    {children}

                    <TeaserButton
                        url={url}
                        structuredText={link}
                        document={document}
                        label={t("teaser.link.default-label")}
                        type={"primary"}
                        icon={"arrowRight"}
                        iconPosition={"right"}
                    />
                </div>
            </div>
        </div>
    );
}
